import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FileUploadOptions } from "@cotecna/file-management";
import { AddPhotosDialogData } from "./add-photos-dialog-data";
import { InspectionPhotoService } from "../../services/inspection-photo-service/inspection-photo-service";

const fileUploadOptions = <FileUploadOptions>{
  allowedExtensions: [".png", ".jpg", ".jpeg", ".bmp"],
  chipsVisible: true,
  customPlaceholder: "Drag files or click to upload",
  disabled: false,
  tableMode: false,
  maxAllowedFiles: 20,
  maxSizeAllowedPerFileInMB: 20,
};

@Component({
    selector: "im-add-photos",
    templateUrl: "./add-photos.component.html",
    styleUrls: ["./add-photos.component.scss"],
    standalone: false
})
export class AddPhotosComponent {
  constructor(
    private dialogRef: MatDialogRef<AddPhotosComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: AddPhotosDialogData,
    private uploadService: InspectionPhotoService,
  ) {}

  public files: File[] = [];

  public readyLoading: boolean = true;
  public showComponentError: boolean = false;
  public componentErrorText: string = "";

  public submitButtonDisabled: boolean = true;

  public fileUploadOptions: FileUploadOptions = fileUploadOptions;

  public onFilesSelected(files: File[]): void {
    this.files = files;
    this.submitButtonDisabled = files.length === 0;
  }

  public onWarningDetected(warnings: string[]): void {
    this.showComponentError = true;
    this.componentErrorText = warnings.join("<br>");
  }

  public onInteractionWithComponent(): void {
    this.showComponentError = false;
    this.componentErrorText = "";
  }

  public async submit(): Promise<void> {
    this.readyLoading = false;
    this.dialogRef.disableClose = true;
    try {
      await this.uploadService.uploadPhotos(
        this.dialogData.inspectionId,
        this.files,
      );
      this.readyLoading = true;
      this.dialogRef.close(true);
    } catch (error) {
      this.readyLoading = true;
      this.showComponentError = true;
      this.componentErrorText =
        "An error has occurred while uploading the photos.";
    }
  }

  public cancel() {
    if (this.readyLoading) this.dialogRef.close();
  }

  public onCloseClick() {
    this.dialogRef.close();
  }
}
